import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AssignToEditorModel } from 'src/app/chief-editor/models/assign.to.editor.model';
import { RawImageService } from 'src/app/chief-editor/services/raw.image.service';
import { UserService } from 'src/app/chief-editor/services/user.service';
import { AppUtils } from 'src/app/helpers/app.utils';
import { SelectListItemModel } from 'src/app/models/select.list.item.model';

@Component({
    selector: 'app-raw-image-assign-upsert',
    templateUrl: './raw.image.assign.upsert.component.html',
})
export class RawImageAssignUpsertComponent implements OnInit {
    @Input() public unixTimeStamp;
    @Input() public contributorId;
    editors = new Array<SelectListItemModel>();
    model = new AssignToEditorModel();

    constructor(private userService: UserService,
        public activeModal: NgbActiveModal,
        private imageService: RawImageService,
        private ngxSpinnerService: NgxSpinnerService,
        private toastr: ToastrService) {

    }
    ngOnInit(): void {
        this.getEditors();
    }

    getEditors(): void {
        setTimeout(() => {
            this.ngxSpinnerService.show();
        });
        this.userService.getEditorList(this.unixTimeStamp).subscribe(
            res => {
                this.ngxSpinnerService.hide();
                this.editors = res;
            }, error => {
                this.ngxSpinnerService.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            }
        );
    }

    close(): void {
        this.activeModal.close();
    }

    submit(): void {
        this.editors.forEach(element => {
            if (element.isSelected) {
                this.model.editors.push(element.key);
            }
        });
        if (this.model.editors.length === 0) {
            return;
        }
        this.model.contributorId = this.contributorId;
        this.model.unixTimeStamp = this.unixTimeStamp;
        this.ngxSpinnerService.show();
        this.imageService.assignToEditer(this.model).subscribe(
            () => {
                this.ngxSpinnerService.hide();
                this.close();
                this.toastr.success('Assigned successfully.');
            }, error => {
                this.ngxSpinnerService.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

}
